import { playerExternalRiotId, playerRosterName } from "../../utils/leaderboard/player-display";

interface PlayerNameDisplayProps {
  displayName: string;
  gameName: string;
  tagLine?: string;
  small?: boolean;
}

const nameClass = (small: boolean) =>
  `overflow-hidden text-ellipsis whitespace-nowrap text-left font-bold text-[#e8c872] group-hover:text-[#7b93ff] ${
    small ? "text-[0.9rem]" : "text-[0.98rem]"
  }`;

export const PlayerNameDisplay = ({
  displayName,
  gameName,
  tagLine = "",
  small = false,
}: PlayerNameDisplayProps) => {
  const name = playerRosterName(gameName);
  const riotId = playerExternalRiotId(displayName, tagLine, gameName);
  const showRiotHint = riotId.length > 0 && riotId !== name;

  if (!showRiotHint) {
    return <span className={nameClass(small)}>{name}</span>;
  }

  return (
    <span
      className="group/riot relative inline-flex max-w-full cursor-help outline-none"
      tabIndex={0}
      title={riotId}
      aria-label={`${name}, ${riotId}`}
    >
      <span
        className={`${nameClass(small)} group-focus-visible/riot:underline group-focus-visible/riot:underline-offset-[0.15em]`}
      >
        {name}
      </span>
      <span
        className="pointer-events-none absolute bottom-[calc(100%+0.35rem)] left-0 z-20 translate-y-[4px] whitespace-nowrap rounded-md border border-[var(--surface-card-border)] bg-[var(--surface-card-bg)] px-[0.55rem] py-[0.3rem] text-[0.78rem] font-medium text-[#e8e8ef] opacity-0 shadow-[0_8px_24px_rgba(0,0,0,0.35)] transition-[opacity,transform] duration-150 ease-in-out group-hover/riot:translate-y-0 group-hover/riot:opacity-100 group-focus-visible/riot:translate-y-0 group-focus-visible/riot:opacity-100"
        role="tooltip"
      >
        {riotId}
      </span>
    </span>
  );
};
